export const VISITSTORETOPURCHASE_GET_ERROR = 'VISITSTORETOPURCHASE_GET_ERROR';
export const VISITSTORETOPURCHASE_GET_REQUEST = 'VISITSTORETOPURCHASE_GET_REQUEST';
export const VISITSTORETOPURCHASE_GET_SUCCESS = 'VISITSTORETOPURCHASE_GET_SUCCESS';
export const VISITSTORETOPURCHASE_ZIPCODE_CHANGE = 'VISITSTORETOPURCHASE_ZIPCODE_CHANGE';
export const SET_SERVICE_ERROR = 'SET_SERVICE_ERROR';
export const CLEAR_SERVICE_ERROR = 'CLEAR_SERVICE_ERROR';
